(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-content"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-section-id]');
    if (!section) return;
    var buttons = section.querySelectorAll('.faq-content__question');
    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var answerId = btn.getAttribute('aria-controls');
        var answer = document.getElementById(answerId);
        if (!answer) return;
        btn.setAttribute('aria-expanded', String(!expanded));
        if (expanded) {
          answer.setAttribute('hidden', '');
        } else {
          answer.removeAttribute('hidden');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
